// extracted by mini-css-extract-plugin
export default {"admin-menu":"AdminMenu_admin-menu__9tXgG","active":"AdminMenu_active__mTweZ"};